 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","dashboards":"dashboards","singleWidget":"singleWidget"}[chunkId]||chunkId) + "." + {"about":"d0304010","dashboards":"01fe5ef7","singleWidget":"4456a059","chunk-00096960":"af241960","chunk-06237b20":"ab5a7c0a","chunk-2a0e8831":"f2a01410","chunk-494b4e8f":"b81db341","chunk-4a8ee7d2":"872818f5","chunk-85c99012":"326357a9","chunk-0d212c89":"f8c3cd7e","chunk-44e7bea8":"e4aee36f","chunk-7139a996":"28adef0f","chunk-8d615bb4":"4252e758","chunk-95a4021e":"2d4d6c31","chunk-a3eddc70":"04f6c052","chunk-246b01cc":"25837286","chunk-61b9111c":"87420eb2","chunk-7fb6487a":"2b6b052b","chunk-9dabcfbe":"a29a0c9a","chunk-2d0de69c":"82f8f14b","chunk-b31482e2":"63624831","chunk-02fcf5ac":"0cf2bed9","chunk-0c70eeac":"9afa7509","chunk-14e27c39":"c5dc843d","chunk-18a8b9e3":"da807cf1","chunk-1b52b73a":"64789062","chunk-23da1178":"d154c9f9","chunk-2598ba5c":"06ac5982","chunk-27b6a0ac":"d8b460de","chunk-0dac3883":"2008c7de","chunk-0ecec252":"121578d1","chunk-12d69420":"41a48fd0","chunk-282d23de":"24e8aa04","chunk-2a803392":"d1dc8c9d","chunk-2fbb0b68":"a5847622","chunk-4f708bcb":"229b8fef","chunk-50e57d13":"51458ce3","chunk-5ad4d493":"377f2045","chunk-5c1141da":"1544bb61","chunk-60a49c35":"43d19b66","chunk-69ea733f":"6b29b09a","chunk-c71e13f4":"242834c8","chunk-cf0797b2":"c941b616","chunk-289d94f4":"0e692e44","chunk-296fbe2e":"9c738b5a","chunk-2d21f268":"cdcbaa8b","chunk-32733c33":"ff70ff26","chunk-331e1184":"98e8f3ce","chunk-335c052f":"379d886a","chunk-37c188e7":"122b1add","chunk-3d8f3fdb":"e9978d40","chunk-400cf449":"a68fbe06","chunk-40cc7762":"6510f782","chunk-41bae43a":"43ea925e","chunk-4a6c5387":"d0fa34c0","chunk-05cf0fe0":"5cba55b5","chunk-08fcf2bc":"bbcf165b","chunk-16ee00c6":"09380905","chunk-1faf12e7":"6af4b234","chunk-30204c0e":"257610c7","chunk-32dc4b57":"d3094c04","chunk-47160af0":"c93c183b","chunk-4a3ab512":"70895c5d","chunk-6faa4cd2":"b69f0cf7","chunk-ab167712":"f7972962","chunk-2ab8e170":"6123777e","chunk-70d6a35e":"8828b805","chunk-d5fe3044":"33a5548a","chunk-4dedfd13":"8d201c65","chunk-5120b600":"b48e1819","chunk-56ef0bc9":"945ed6e2","chunk-578945a2":"21d25152","chunk-204c83d5":"702febb0","chunk-58041e0c":"6114694a","chunk-60cc9c3a":"0e0e680b","chunk-64c3632a":"6518cec7","chunk-6a0c883c":"3fa9ea0f","chunk-73dbdb10":"d42d4c28","chunk-7478ae69":"bd8f5da1","chunk-7814d877":"e3df70f1","chunk-2d0d7477":"1c46a680","chunk-2d20f727":"7103497b","chunk-783246d2":"750a7d02","chunk-7ad038b6":"942672c2","chunk-7facd18a":"5565c052","chunk-80af841e":"3187da77","chunk-bc12db8a":"e69a6e26","chunk-d4335ec8":"8343f2f1","chunk-dfd1bdc6":"d3395404","chunk-02bcab7c":"c4182451","chunk-1bdd0a64":"0de3230f","chunk-0a8be1cc":"f45bf729","chunk-0be9bb5c":"384189db","chunk-23e3fd4c":"ee3f7cc5","chunk-33df020a":"5fb2af46","chunk-619fcfce":"87c4353a","chunk-2d2308c2":"7fb23c61","chunk-af058678":"549f7fd0","chunk-011b45b0":"d95c7159","chunk-288483e8":"0a88638c","chunk-5d47c838":"57ad08a3","chunk-76cbf94b":"742a17a6","chunk-6ed4a524":"59d3fe6a","chunk-ed918d1a":"81ff73ca","chunk-992faf96":"c0b52aff","chunk-2d0b2933":"8b137b85","chunk-479b0d84":"29d18b67","chunk-dcd90a58":"177c2e0d","chunk-3430e598":"7a80325b","chunk-4f850b74":"d0ea8a88","chunk-97bc2c26":"1d79f4be","chunk-e14c733e":"679e8bee"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"dashboards":1,"chunk-00096960":1,"chunk-246b01cc":1,"chunk-9dabcfbe":1,"chunk-2598ba5c":1,"chunk-27b6a0ac":1,"chunk-40cc7762":1,"chunk-6faa4cd2":1,"chunk-ab167712":1,"chunk-578945a2":1,"chunk-204c83d5":1,"chunk-6a0c883c":1,"chunk-02bcab7c":1,"chunk-23e3fd4c":1,"chunk-33df020a":1,"chunk-288483e8":1,"chunk-76cbf94b":1,"chunk-479b0d84":1,"chunk-dcd90a58":1,"chunk-3430e598":1,"chunk-4f850b74":1,"chunk-97bc2c26":1,"chunk-e14c733e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","dashboards":"dashboards","singleWidget":"singleWidget"}[chunkId]||chunkId) + "." + {"about":"53b29abe","dashboards":"c4e87b19","singleWidget":"31d6cfe0","chunk-00096960":"1dc3c0c0","chunk-06237b20":"31d6cfe0","chunk-2a0e8831":"31d6cfe0","chunk-494b4e8f":"31d6cfe0","chunk-4a8ee7d2":"31d6cfe0","chunk-85c99012":"31d6cfe0","chunk-0d212c89":"31d6cfe0","chunk-44e7bea8":"31d6cfe0","chunk-7139a996":"31d6cfe0","chunk-8d615bb4":"31d6cfe0","chunk-95a4021e":"31d6cfe0","chunk-a3eddc70":"31d6cfe0","chunk-246b01cc":"9cc29893","chunk-61b9111c":"31d6cfe0","chunk-7fb6487a":"31d6cfe0","chunk-9dabcfbe":"e009864f","chunk-2d0de69c":"31d6cfe0","chunk-b31482e2":"31d6cfe0","chunk-02fcf5ac":"31d6cfe0","chunk-0c70eeac":"31d6cfe0","chunk-14e27c39":"31d6cfe0","chunk-18a8b9e3":"31d6cfe0","chunk-1b52b73a":"31d6cfe0","chunk-23da1178":"31d6cfe0","chunk-2598ba5c":"9b09d052","chunk-27b6a0ac":"063337b5","chunk-0dac3883":"31d6cfe0","chunk-0ecec252":"31d6cfe0","chunk-12d69420":"31d6cfe0","chunk-282d23de":"31d6cfe0","chunk-2a803392":"31d6cfe0","chunk-2fbb0b68":"31d6cfe0","chunk-4f708bcb":"31d6cfe0","chunk-50e57d13":"31d6cfe0","chunk-5ad4d493":"31d6cfe0","chunk-5c1141da":"31d6cfe0","chunk-60a49c35":"31d6cfe0","chunk-69ea733f":"31d6cfe0","chunk-c71e13f4":"31d6cfe0","chunk-cf0797b2":"31d6cfe0","chunk-289d94f4":"31d6cfe0","chunk-296fbe2e":"31d6cfe0","chunk-2d21f268":"31d6cfe0","chunk-32733c33":"31d6cfe0","chunk-331e1184":"31d6cfe0","chunk-335c052f":"31d6cfe0","chunk-37c188e7":"31d6cfe0","chunk-3d8f3fdb":"31d6cfe0","chunk-400cf449":"31d6cfe0","chunk-40cc7762":"ff4777ab","chunk-41bae43a":"31d6cfe0","chunk-4a6c5387":"31d6cfe0","chunk-05cf0fe0":"31d6cfe0","chunk-08fcf2bc":"31d6cfe0","chunk-16ee00c6":"31d6cfe0","chunk-1faf12e7":"31d6cfe0","chunk-30204c0e":"31d6cfe0","chunk-32dc4b57":"31d6cfe0","chunk-47160af0":"31d6cfe0","chunk-4a3ab512":"31d6cfe0","chunk-6faa4cd2":"ff4777ab","chunk-ab167712":"5e676caf","chunk-2ab8e170":"31d6cfe0","chunk-70d6a35e":"31d6cfe0","chunk-d5fe3044":"31d6cfe0","chunk-4dedfd13":"31d6cfe0","chunk-5120b600":"31d6cfe0","chunk-56ef0bc9":"31d6cfe0","chunk-578945a2":"ff4777ab","chunk-204c83d5":"b1897b73","chunk-58041e0c":"31d6cfe0","chunk-60cc9c3a":"31d6cfe0","chunk-64c3632a":"31d6cfe0","chunk-6a0c883c":"31a2f080","chunk-73dbdb10":"31d6cfe0","chunk-7478ae69":"31d6cfe0","chunk-7814d877":"31d6cfe0","chunk-2d0d7477":"31d6cfe0","chunk-2d20f727":"31d6cfe0","chunk-783246d2":"31d6cfe0","chunk-7ad038b6":"31d6cfe0","chunk-7facd18a":"31d6cfe0","chunk-80af841e":"31d6cfe0","chunk-bc12db8a":"31d6cfe0","chunk-d4335ec8":"31d6cfe0","chunk-dfd1bdc6":"31d6cfe0","chunk-02bcab7c":"49aa0100","chunk-1bdd0a64":"31d6cfe0","chunk-0a8be1cc":"31d6cfe0","chunk-0be9bb5c":"31d6cfe0","chunk-23e3fd4c":"ff4777ab","chunk-33df020a":"ff4777ab","chunk-619fcfce":"31d6cfe0","chunk-2d2308c2":"31d6cfe0","chunk-af058678":"31d6cfe0","chunk-011b45b0":"31d6cfe0","chunk-288483e8":"ff4777ab","chunk-5d47c838":"31d6cfe0","chunk-76cbf94b":"ff4777ab","chunk-6ed4a524":"31d6cfe0","chunk-ed918d1a":"31d6cfe0","chunk-992faf96":"31d6cfe0","chunk-2d0b2933":"31d6cfe0","chunk-479b0d84":"ff4777ab","chunk-dcd90a58":"ff4777ab","chunk-3430e598":"ff4777ab","chunk-4f850b74":"b1897b73","chunk-97bc2c26":"958546cc","chunk-e14c733e":"ff4777ab"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
